var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHomeSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F6F6",
    width: 48,
    height: 48,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33.75H14.36a.75.75 0 1 1 0-1.5H15V21.748l-.157-.124a3.754 3.754 0 0 1-1.274-2.17l-.035-.215a3.755 3.755 0 0 1 1.065-3.142l1.188-1.187a2.25 2.25 0 0 1 1.591-.66h13.244a2.25 2.25 0 0 1 1.59.66l1.19 1.189a3.75 3.75 0 0 1-.245 5.528l-.158.123v10.5h.641a.75.75 0 0 1 .743.648l.007.102a.75.75 0 0 1-.75.75H30zm-1.5-12.002-.065.05a3.737 3.737 0 0 1-2.184.702c-.79 0-1.552-.248-2.183-.7L24 21.748l-.064.05c-.57.41-1.249.655-1.967.696l-.217.006a3.743 3.743 0 0 1-2.183-.699l-.068-.052-.033.027c-.804.59-1.805.83-2.776.684l-.192-.035v9.825h8.25l.001-6.75a1.5 1.5 0 0 1 1.356-1.493L26.25 24h3a1.5 1.5 0 0 1 1.5 1.5v6.75h.75v-9.826l-.19.034a3.756 3.756 0 0 1-2.776-.683l-.035-.027zm.75 3.752h-3v6.75h3V25.5zM22.5 24a1.5 1.5 0 0 1 1.5 1.5v3.749a1.5 1.5 0 0 1-1.5 1.5l-3.722-.001-.028.002a1.5 1.5 0 0 1-1.493-1.355l-.007-.145V25.5a1.5 1.5 0 0 1 1.5-1.5h3.75zm0 1.5h-3.75v3.748l3.75.001V25.5zm-5.121-9.75a.75.75 0 0 0-.53.22l-1.189 1.188a2.254 2.254 0 0 0 .466 3.541l.01.007.145.077c.848.404 1.86.238 2.534-.416l.122-.128a.75.75 0 0 1 1.126 0c.426.485 1.04.762 1.687.761.655 0 1.262-.28 1.688-.762a.75.75 0 0 1 1.125 0c.426.485 1.04.763 1.687.762.655 0 1.262-.28 1.688-.762a.75.75 0 0 1 1.124 0 2.251 2.251 0 0 0 2.813.46l.006-.004.141-.087a2.25 2.25 0 0 0 .93-1.391l.029-.172a2.25 2.25 0 0 0-.64-1.884l-1.19-1.19a.75.75 0 0 0-.53-.22H17.379z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomeSquare);
export default __webpack_public_path__ + "static/media/ico-home-square.1db17d90751e5821d5e7c6691be43c18.svg";
export { ForwardRef as ReactComponent };